import { useEffect } from "react";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { TrustStrip } from "@/components/sections/TrustStrip";
import { About } from "@/components/sections/About";
import { WhyChooseUs } from "@/components/sections/WhyChooseUs";
import { Services } from "@/components/sections/Services";
import { EditorialMarquee } from "@/components/sections/Marquee";
import { Gallery } from "@/components/sections/Gallery";
import { Testimonials } from "@/components/sections/Testimonials";
import { FAQ } from "@/components/sections/FAQ";
import { QuoteForm } from "@/components/sections/QuoteForm";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import { api } from "@/lib/api";

export default function Landing() {
  useEffect(() => {
    if (!sessionStorage.getItem("cgc_viewed")) {
      sessionStorage.setItem("cgc_viewed", "1");
      api.post("/track/view").catch(() => {});
    }
  }, []);

  return (
    <div className="App bg-brand-ink text-white">
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <About />
        <WhyChooseUs />
        <Services />
        <EditorialMarquee />
        <Gallery />
        <Testimonials />
        <FAQ />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
